import API from "../utility/axios";
export class AdminService {
    static addUser(data: any): Promise<any> {
        return API.post(`/createUser`, data);
    }

    static createrole(data: any): Promise<any> {
        return API.post(`/createrole`, data);
    }

    static createfilterAccess(data: any): Promise<any> {
        return API.post(`/createfilterAccess`, data);
    }

    static updatefilterAccess(data: any): Promise<any> {
        return API.post(`/updatefilterAccess`, data);
    }

    static createCollege(data: any): Promise<any> {
        return API.post(`/createCollege`, data);
    }


    static createHeaderData(data: any): Promise<any> {
        return API.post(`/createHeaderData`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }


    static uploadXlsx(data: any): Promise<any> {
        return API.post(`/upload-lms-excel`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }





    static adminUpdateUser(data: any): Promise<any> {
        return API.post(`/adminUpdateUser`, data);
    }


    static createResume(data: any): Promise<any> {
        return API.post(`/createResume`, data);
    }

    static updateConversionList(data: any): Promise<any> {
        return API.post(`/updateConversionList`, data);
    }

    static assignBdiAndUpdateMessage(data: any): Promise<any> {
        return API.post(`/assignBdiAndUpdateMessage`, data);
    }

    

    static addPercentage(data: any): Promise<any> {
        return API.post(`/createPercentage`, data);
    }

    static updatePercentage(data: any): Promise<any> {
        return API.post(`/updatePercentage`, data);
    }



    static generateToken(data: any): Promise<any> {
        return API.post(`/generateToken`, data);
    }

    static getConversions(data: any): Promise<any> {
        return API.post(`/getConversions`, data);
    }

    static getManagerConversions(data: any): Promise<any> {
        return API.post(`/getManagerConversions`, data);
    }

    static getBdiUsersList(data: any): Promise<any> {
        return API.post(`/getBdiUsersList`, data);
    }
    

    static allProjectData(data: any): Promise<any> {
        return API.get(`/allProjectData`, { params: data });
    }

    static getAllUserDetails(data: any): Promise<any> {
        return API.get(`/allUsersList`, { params: data });
    }

    static getBDIUsers(data: any): Promise<any> {
        return API.get(`/getBDIUsers`, { params: data });
    }
    static getManagerUsers(data: any): Promise<any> {
        return API.get(`/getManagerUsers`, { params: data });
    }


    


    static getConversionList(data: any): Promise<any> {
        return API.get(`/getConversionList`, { params: data });
    }
    static getTopPerformersByMonth(month: any, year: any): Promise<any> {
        return API.get(`/getTopPerformersByMonth`, {
            params: {
                month,
                year
            }
        });
    }

    static getMonthWiseUserConversions(year: any): Promise<any> {
        return API.get(`/getMonthWiseUserConversions`, {
            params: {
                year
            }
        });
    }


    static getMonthSingleUserConversions(year: any, userId: any): Promise<any> {
        return API.get(`/getMonthWiseSingleUserConversions`, {
            params: {
                year,
                userId
            }
        });
    }



    static activeUser(data: any): Promise<any> {
        return API.post(`/activeuser`, data);
    }

    static getManagerList(data: any): Promise<any> {
        return API.post(`/getManagerList`, data);
    }



    static createMeet(data: any): Promise<any> {
        return API.post(`/createmeet`, data);
    }

    //Batch


    static createbatch(data: any): Promise<any> {
        return API.post(`/createbatch`, data);
    }
    static createPayment(data: any): Promise<any> {
        return API.post(`/createPayment`, data);
    }
    static updateMeet(data: any): Promise<any> {
        return API.post(`/updatemeet`, data);
    }

    static updateBatch(data: any): Promise<any> {
        return API.post(`/updatebatch`, data);
    }


    static deleteUser(data: any): Promise<any> {
        return API.post(`/deleteUser`, data);
    }
    static updateActiveFlag(data: any): Promise<any> {
        return API.post(`/updateActiveFlag`, data);
    }
    
    
    static deleteRegister(data: any): Promise<any> {
        return API.post(`/deleteRegister`, data);
    }

    static deleteAssessment(data: any): Promise<any> {
        return API.post(`/deleteAssessment`, data);
    }

    static deleteCollege(data: any): Promise<any> {
        return API.post(`/deleteCollege`, data);
    }

    static deleteUploadList(data: any): Promise<any> {
        return API.post(`/deleteUploadList`, data);
    }

    static assignBdiToUploads(data: any): Promise<any> {
        return API.post(`/assignBdiToUploads`, data);
    }

    static deleteFilterAccess(data: any): Promise<any> {
        return API.post(`/deletefilterAccess`, data);
    }

    static deleteQuestions(data: any): Promise<any> {
        return API.post(`/deletequestion`, data);
    }

    static deleteGuest(data: any): Promise<any> {
        return API.post(`/deleteGuest`, data);
    }

    


    

    static deleteResume(data: any): Promise<any> {
        return API.post(`/deleteResume`, data);
    }



    static deleteCertificatesByEmail(data: any): Promise<any> {
        return API.post(`/deleteCertificatesByEmail`, data);
    }



    static updateRegisterAmb(data: any): Promise<any> {
        return API.post(`/updateRegisterAmb`, data);
    }

    static deletePayment(data: any): Promise<any> {
        return API.post(`/deletePayment`, data);
    }
    static userAccess(data: any): Promise<any> {
        return API.post(`/userAccess`, data);
    }
    static getAllMeets(data: any): Promise<any> {
        return API.get(`/allmeets`);
    }

    static getAllBatch(data: any): Promise<any> {
        return API.get(`/allbatch`);
    }

    static createCourse(data: any): Promise<any> {
        return API.post(`/createcourse`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static updateCourse(data: any): Promise<any> {
        return API.post(`/updatecourse`, data, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }

    static getAllRegisterList(data: any): Promise<any> {
        return API.get(`/allRegisterList`, { params: data });
    }





    static allUploadList(data: any): Promise<any> {
        return API.get(`/allUploadList`);
    }


    static getAllPercentageList(data: any): Promise<any> {
        return API.get(`/allPercentage`, { params: data });
    }

    static getAllrolesList(data: any): Promise<any> {
        return API.get(`/allroles`, { params: data });
    }

    static allfilterAccessList(data: any): Promise<any> {
        return API.get(`/allfilterAccess`, { params: data });
    }

    static allQuestionsList(data: any): Promise<any> {
        return API.get(`/allquestion`, { params: data });
    }

    static getExamDashboardStats(data: any): Promise<any> {
        return API.get(`/getExamDashboardStats`, { params: data });
    }

    static allGuestList(resultId: any): Promise<any> {
        return API.get(`/allGuestList/${resultId}`);
    }

    static getAllResumeList(data: any): Promise<any> {
        return API.get(`/allResume`, { params: data });
    }

    static getAllHeaderData(data: any): Promise<any> {
        return API.get(`/allHeaderData`, { params: data });
    }
    static allCollege(data: any): Promise<any> {
        return API.get(`/allCollege`, { params: data });
    }

    static getCollegeByName(collegeName: string): Promise<any> {
        return API.get(`/college/${collegeName}`);
    }

    static allQuestions(collegeId: any) {
        return API.get(`/question/${collegeId}`);
      }


    static privateCerificate(data: any): Promise<any> {
        return API.post(`/getPrivateCerificate`, data);
    }



    static getAllPaymentList(data: any): Promise<any> {
        return API.get(`/getPayment`, { params: data });
    }

    static getAllQueriesList(data: any): Promise<any> {
        return API.get(`/allQueriesList`, { params: data });
    }

    static deleteQueries(data: any): Promise<any> {
        return API.post(`/deleteQueries`, data);
    }

    static deleteMeet(data: any): Promise<any> {
        return API.post(`/deleteMeet`, data);
    }

    static deleteProject(data: any): Promise<any> {
        return API.post(`/deleteProject`, data);
    }



    static deleteBatch(data: any): Promise<any> {
        return API.post(`/deletebatch`, data);
    }

    static deletePercentage(data: any): Promise<any> {
        return API.post(`/deletePercentage`, data);
    }

    static deleteCareerGuidances(data: any): Promise<any> {
        return API.post(`/deleteCareerGuidance`, data);
    }

    static deleteCgpa(data: any): Promise<any> {
        return API.post(`/deleteCgpa`, data);
    }



    static getCourseList(data: any): Promise<any> {
        return API.get(`/allcourses`, { params: data });
    }

    static deleteCourse(data: any): Promise<any> {
        return API.post(`/deleteCourse`, data);
    }

    static deleteLms(data: any): Promise<any> {
        return API.post(`/deleteLms`, data);
    }

    static courseInfo(data: any): Promise<any> {
        return API.post(`/courseInfo`, data);
    }

    static getallCertificatesList(data: any): Promise<any> {
        return API.get(`/allCertificatesList`, { params: data });
    }

    static getallProjectsList(data: any): Promise<any> {
        return API.get(`/allprojects`, { params: data });
    }


    static getProjectByBatch(data: any): Promise<any> {
        return API.post(`/getProjectByBatch`, data);
    }


    static getProjectByEmail(data: any): Promise<any> {
        return API.post(`/getProjectByEmail`, data);
    }



    


    static createCertificate(data: any): Promise<any> {
        return API.post(`/createCertificate`, data);
    }

    static createLoa(data: any): Promise<any> {
        return API.post(`/createLoa`, data);
    }

    static createAttendance(data: any): Promise<any> {
        return API.post(`/createAttendance`, data);
    }


    // static createCertificate(data: any): Promise<any> {
    //     console.log("data",data)
    //     return API.post(`/createCertificate`, data, {
    //         headers: {
    //             'Content-Type': 'multipart/form-data'
    //         }
    //     });
    // }
    static createProject(data: any): Promise<any> {
        return API.post(`/createProject`, data);
    }

    static updateProject(data: any): Promise<any> {
        return API.post(`/updateProject`, data);
    }

    static createTask(data: any): Promise<any> {
        return API.post(`/createTask`, data);
    }

    static getAllCgpaList(data: any): Promise<any> {
        return API.get(`/allCgpaLists`, { params: data });
    }
    static getallCareerGuidancesList(data: any): Promise<any> {
        return API.get(`/allCareerGuidances`, { params: data });
    }

    static createCgpaAccess(data: any): Promise<any> {
        return API.post(`/createCgpaAccess`, data);
    }
    static updateCareerGuidance(data: any): Promise<any> {
        return API.post(`/updateCareerGuidance`, data);
    }
    static createLms(data: any): Promise<any> {
        return API.post(`/createLms`, data);
    }
    static editLms(data: any): Promise<any> {
        return API.post(`/editLms`, data);
    }


    static getallLmslist(data: any): Promise<any> {
        return API.get(`/allLms`, { params: data });
    }
    static allLmsData(data: any): Promise<any> {
        return API.post(`/allLmsData`, data);
    }


    static createSignupList(data: any): Promise<any> {
        return API.post(`/createSignUpList`, data);
    }



    static allSignUpList(data: any): Promise<any> {
        return API.get(`/allSignUpList`, { params: data });
    }
    static allTasks(data: any): Promise<any> {
        return API.get(`/allTasks`, { params: data });
    }


    static allAlert(data: any): Promise<any> {
        return API.get(`/allalert`, { params: data });
    }

    static deleteAlert(data: any): Promise<any> {
        return API.post(`/deletealert`, data);
    }

    static updateAlert(data: any): Promise<any> {
        return API.post(`/updatealert`, data);
    }

    static createAlert(data: any): Promise<any> {
        return API.post(`/createalert`, data);
    }
    static createQuestions(data: any): Promise<any> {
        return API.post(`/createquestion`, data);
    }

    static editAlert(data: any): Promise<any> {
        return API.post(`/editalert`, data);
    }

    static updateQuestions(data: any): Promise<any> {
        return API.post(`/editquestion`, data);
    }

    static alertshow(data: any): Promise<any> {
        return API.post(`/alertshow`, data);
    }





    static deleteSignUpList(data: any): Promise<any> {
        return API.post(`/deleteSignupList`, data);
    }
    static deleteTaskList(data: any): Promise<any> {
        return API.post(`/deleteTaskList`, data);
    }


    static getAllSignUpList(data: any): Promise<any> {
        return API.get(`/allSignUpList`);
    }


}